import React from 'react'
import { Button } from '../../../Button/Button'

export interface AddIconButtonProps {
  label: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  disabled?: boolean
  className?: string
  style?: React.CSSProperties
}

export const AddIconButton: React.FC<AddIconButtonProps> = ({ label, onClick, disabled, className, style }) => (
  <Button type='button' variant='secondary' className={className} style={style} disabled={disabled} onClick={onClick}>
    <i className='bi bi-plus-lg me-1' />
    {label}
  </Button>
)

export interface RemoveIconButtonProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  disabled?: boolean
  className?: string
  style?: React.CSSProperties
}

export const RemoveIconButton: React.FC<RemoveIconButtonProps> = ({ onClick, disabled, className, style }) => (
  <Button type='button' variant='borderless' aria-label='Remove item' className={className} style={style} disabled={disabled} onClick={onClick}>
    <i className='bi bi-trash' />
  </Button>
)
